import * as PIXI from 'pixi.js';
import { Spine } from 'pixi-spine';

import { Text } from 'pixi.js'
import { Stage, applyDefaultProps, PixiComponent } from '@inlet/react-pixi'

let spineData = null;

export default PixiComponent('SpineComponent', {
  create: ({ spineData })  => {
    // instantiate something and return it.
    // for instance:
        const animation = new Spine(spineData);

        let animationName = "idle";
        
        if (animation.state.hasAnimation(animationName)) {
//            console.log("has animation!");
            // idle forever, little boy!
            animation.state.setAnimation(0, animationName, true);
            // dont idle too fast
            animation.state.timeScale = 0.25;
        }

        return animation; 
  },
  didMount: (instance, parent) => {
    // apply custom logic on mount
  },
  willUnmount: (instance, parent) => {
    // clean up before removal
  },
  applyProps: (instance, oldProps, newProps) => {
    // props changed
    // apply logic to the instance
    const {
        mixes = [],
        scale = 1,
        animationStateCallback,
        ...newP
    } = newProps;
    applyDefaultProps(instance, oldProps, newP);
    instance.scale.set(scale);
  /*  mixes.forEach(mix =>
        instance.stateData.setMix(mix.from, mix.to, mix.duration)
    );

    if (animationStateCallback) {
        animationStateCallback(instance.state);
    }
    */  
  },
  config: {
    // destroy instance on unmount?
    // default true
    destroy: true,

    /// destroy its children on unmount?
    // default true
    destroyChildren: true,
  },
})